import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { MyBusinessApiService } from '@app/modules/my-business/services/my-business.api.service';
import { map, shareReplay } from 'rxjs/operators';

@Component({
  selector: 'sbnb-businesses',
  templateUrl: './businesses.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessesComponent {
  private readonly myBusinessApiService = inject(MyBusinessApiService);
  private readonly router = inject(Router);
  private readonly userPermissionsService = inject(UserPermissionsService);
  public businesses$ = this.myBusinessApiService.getBusinesses().pipe(shareReplay(1));
  public columns = ['name', 'type', 'properties'];
  public isAdmin$ = this.userPermissionsService
    .isPrimaryUser()
    .pipe(map((isPrimaryUser) => isPrimaryUser || this.userPermissionsService.isAdmin()));

  public routeToNew() {
    this.router.navigate(['/operations/my-business/businesses/new']);
  }
}
